import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import Dashboard from "./Dashboard";
import Drawer from "~/containers/DrawerSocietario/index";
import Layout from "~/components/UI/Layout/Layout";
import * as dashTasksActions from "~/_domains/societario/actions";
import * as drawerSocietarioActions from "~/containers/DrawerSocietario/actions";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";
import DrawerLeads from "~/_domains/leads/components/Drawer";
import CustomerForm from "~/_domains/customers/drawer/index";

export const ScreensFinanceiroPainel = () => {
  var dispatch = useDispatch();
  var location = useLocation();

  var [isLoading, setIsLoading] = useState(true);

  useEffect(function() {
    loadData();
  }, []);

  // Abre uma tarefa específica via ?task_id= (mesma mecânica do painel societário)
  useEffect(function() {
    var params = new URLSearchParams(location.search);
    var taskId = params.get("task_id");

    if (taskId && !isLoading) {
      dispatch(dashTasksActions.getDashTaskById(taskId))
        .then(function(response) {
          var taskData = response && response.payload && response.payload.data && response.payload.data.data;
          if (taskData) {
            dispatch(drawerSocietarioActions.show(taskData.category, { data: taskData, category: taskData.category }));
          }
        })
        .catch(function(error) {
          console.error("Error loading task:", error);
        });
    }
  }, [location.search, isLoading]);

  async function loadData() {
    try {
      await Promise.all([
        dispatch(dashTasksActions.loadDashTasks({ showLoading: false })),
      ]);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <LoadingTopBar isActive={isLoading} />
      <Layout>
        <DrawerLeads />
        <CustomerForm />
        <Dashboard />
        <Drawer />
      </Layout>
    </div>
  );
};
